// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    suggestionPosition: 'right'
  }
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
		if (!suggestionElement) suggestionElement = this.$uiMenuElement; 
		if (!searchElement) searchElement = this.$element;
		if (!searchBoxId) searchBoxId = this.id;
	};

  var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    var localeURLPart = "";

    if (hasShopifyRoutes) {
        localeURLPart = Shopify.routes.root.replace(/\/$/, '');
    } else if (elements.indexOf(boostPFSConfig.general.current_locale) > -1) {
        localeURLPart = "/" + boostPFSConfig.general.current_locale;
    }
  
    InstantSearchResultItemProduct.prototype.afterRender = function() {
      if (this.hasOwnProperty('data') && this.data !== null) {
        var data = this.data;
        quickUrl = localeURLPart + '/products/' + this.data.handle + '?view=boost-pfs-integration';
        jQ.ajax({
            url: quickUrl,
            success: function(result) {
            var res = JSON.parse(result)
            
                jQ('[data-id="' + res.id + '"]').find('.boost-pfs-search-suggestion-product-price').html(res.custom_price.trim());
            }
        });
      }
    }

 //    function buildPrice(data) {
	// 	var html = '';
 //        var onSale = data.compare_at_price_min > data.price_min;
 //        var priceVaries = data.price_min < data.price_max;

	// 		if (onSale) {
	// 			html += '<span class="boost-pfs-search-suggestion-product-sale-price" style="white-space: nowrap; display: block;">' + Utils.formatMoney(data.price_min, undefined, true) + '</span>';
	// 			html += '<s style="white-space: nowrap;">' + Utils.formatMoney(data.compare_at_price_min, undefined, true) + '</s> ';
			
	// 		} else {
 //              html += '<span class="boost-pfs-search-suggestion-product-regular-price" style="white-space: nowrap; display: block;">' + Utils.formatMoney(data.price_min, '', true) + '</span>';
	// 		}
		
	// 	return html;
	// }

})();